/*! For license information please see vendor.js.LICENSE.txt */
(function () {
    var t = {
        408: function (t) {
            !(function (e, i) {
                true ? (t.exports = i()) : 0;
            })(this, function () {
                return (() => {
                    "use strict";
                    var t = {
                            d: (e, i) => {
                                for (var n in i) t.o(i, n) && !t.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: i[n] });
                            },
                            o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
                            r: (t) => {
                                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
                            },
                        },
                        e = {};
                    function i(t, e) {
                        for (var i = 0; i < e.length; i++) {
                            var n = e[i];
                            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                        }
                    }
                    function n(t, e, n) {
                        return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
                    }
                    function s(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }
                    function r(t, e, i) {
                        return e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i), t;
                    }
                    t.r(e), t.d(e, { default: () => a });
                    var o = { overlay: null, thickness: "3px", color: "gray", startDuration: 1e3, finishDuration: 300 },
                        a = n(function t() {
                            var e = this,
                                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.body,
                                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            s(this, t),
                                r(this, "setLoadingData", function () {
                                    var t = e.target,
                                        i = e.options,
                                        n = i.startDuration,
                                        s = i.finishDuration,
                                        r = i.thickness,
                                        o = i.color;
                                    t.style.setProperty("--al-thickness", " ".concat(r)),
                                        t.style.setProperty("--al-color", " ".concat(o)),
                                        t.style.setProperty("--al-start-duration", " ".concat(n, "ms")),
                                        t.style.setProperty("--al-finish-duration", " ".concat(s, "ms"));
                                }),
                                r(this, "start", function () {
                                    e.target.classList.add("al-loading-bar", "start", "loading"), e.overlay && e.overlay.classList.add("al-loading-overlay", "overlay-show");
                                }),
                                r(this, "finish", function () {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {},
                                        i = e.target,
                                        n = e.overlay,
                                        s = e.cleanUp,
                                        r = e.options.finishDuration,
                                        o = window.getComputedStyle(i, ":before").width;
                                    i.style.setProperty("--al-end-width", o),
                                        i.classList.add("loaded"),
                                        i.classList.remove("loading"),
                                        window.requestAnimationFrame(function () {
                                            i.classList.add("finished"), e.overlay && n.classList.remove("overlay-show");
                                        }),
                                        setTimeout(s, 2 * r),
                                        setTimeout(t, r);
                                }),
                                r(this, "cleanUp", function () {
                                    e.target.classList.remove("al-loading-bar", "start", "loaded", "finished"), e.overlay && e.overlay.classList.remove("al-loading-overlay");
                                }),
                                (this.options = Object.assign({}, o, n)),
                                (this.target = i),
                                (this.overlay = this.options.overlay),
                                this.setLoadingData();
                        });
                    return e;
                })();
            });
        },
        476: function (t, e, i) {
            var n, s;
            (function (r, o) {
                "use strict";
                if (true) !((n = o), (s = "function" === typeof n ? n.call(e, i, e, t) : n), void 0 !== s && (t.exports = s));
            })(window, function t() {
                "use strict";
                var e = (function () {
                    var t = window.Element.prototype;
                    if (t.matches) return "matches";
                    if (t.matchesSelector) return "matchesSelector";
                    var e = ["webkit", "moz", "ms", "o"];
                    for (var i = 0; i < e.length; i++) {
                        var n = e[i];
                        var s = n + "MatchesSelector";
                        if (t[s]) return s;
                    }
                })();
                return function t(i, n) {
                    return i[e](n);
                };
            });
        },
        323: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true) !((n = o), (s = "function" === typeof n ? n.call(e, i, e, t) : n), void 0 !== s && (t.exports = s));
            })("undefined" != typeof window ? window : this, function () {
                "use strict";
                function t() {}
                var e = t.prototype;
                e.on = function (t, e) {
                    if (!t || !e) return;
                    var i = (this._events = this._events || {});
                    var n = (i[t] = i[t] || []);
                    if (-1 == n.indexOf(e)) n.push(e);
                    return this;
                };
                e.once = function (t, e) {
                    if (!t || !e) return;
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    var n = (i[t] = i[t] || {});
                    n[e] = true;
                    return this;
                };
                e.off = function (t, e) {
                    var i = this._events && this._events[t];
                    if (!i || !i.length) return;
                    var n = i.indexOf(e);
                    if (-1 != n) i.splice(n, 1);
                    return this;
                };
                e.emitEvent = function (t, e) {
                    var i = this._events && this._events[t];
                    if (!i || !i.length) return;
                    i = i.slice(0);
                    e = e || [];
                    var n = this._onceEvents && this._onceEvents[t];
                    for (var s = 0; s < i.length; s++) {
                        var r = i[s];
                        var o = n && n[r];
                        if (o) {
                            this.off(t, r);
                            delete n[r];
                        }
                        r.apply(this, e);
                    }
                    return this;
                };
                e.allOff = function () {
                    delete this._events;
                    delete this._onceEvents;
                };
                return t;
            });
        },
        664: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(476)]),
                    (s = function (t) {
                        return o(r, t);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i) {
                "use strict";
                var n = {};
                n.extend = function (t, e) {
                    for (var i in e) t[i] = e[i];
                    return t;
                };
                n.modulo = function (t, e) {
                    return ((t % e) + e) % e;
                };
                var s = Array.prototype.slice;
                n.makeArray = function (t) {
                    if (Array.isArray(t)) return t;
                    if (null === t || void 0 === t) return [];
                    var e = "object" == typeof t && "number" == typeof t.length;
                    if (e) return s.call(t);
                    return [t];
                };
                n.removeFrom = function (t, e) {
                    var i = t.indexOf(e);
                    if (-1 != i) t.splice(i, 1);
                };
                n.getParent = function (t, e) {
                    while (t.parentNode && t != document.body) {
                        t = t.parentNode;
                        if (i(t, e)) return t;
                    }
                };
                n.getQueryElement = function (t) {
                    if ("string" == typeof t) return document.querySelector(t);
                    return t;
                };
                n.handleEvent = function (t) {
                    var e = "on" + t.type;
                    if (this[e]) this[e](t);
                };
                n.filterFindElements = function (t, e) {
                    t = n.makeArray(t);
                    var s = [];
                    t.forEach(function (t) {
                        if (!(t instanceof HTMLElement)) return;
                        if (!e) {
                            s.push(t);
                            return;
                        }
                        if (i(t, e)) s.push(t);
                        var n = t.querySelectorAll(e);
                        for (var r = 0; r < n.length; r++) s.push(n[r]);
                    });
                    return s;
                };
                n.debounceMethod = function (t, e, i) {
                    i = i || 100;
                    var n = t.prototype[e];
                    var s = e + "Timeout";
                    t.prototype[e] = function () {
                        var t = this[s];
                        clearTimeout(t);
                        var e = arguments;
                        var r = this;
                        this[s] = setTimeout(function () {
                            n.apply(r, e);
                            delete r[s];
                        }, i);
                    };
                };
                n.docReady = function (t) {
                    var e = document.readyState;
                    if ("complete" == e || "interactive" == e) setTimeout(t);
                    else document.addEventListener("DOMContentLoaded", t);
                };
                n.toDashed = function (t) {
                    return t
                        .replace(/(.)([A-Z])/g, function (t, e, i) {
                            return e + "-" + i;
                        })
                        .toLowerCase();
                };
                var r = e.console;
                n.htmlInit = function (t, i) {
                    n.docReady(function () {
                        var s = n.toDashed(i);
                        var o = "data-" + s;
                        var a = document.querySelectorAll("[" + o + "]");
                        var l = document.querySelectorAll(".js-" + s);
                        var h = n.makeArray(a).concat(n.makeArray(l));
                        var c = o + "-options";
                        var u = e.jQuery;
                        h.forEach(function (e) {
                            var n = e.getAttribute(o) || e.getAttribute(c);
                            var s;
                            try {
                                s = n && JSON.parse(n);
                            } catch (t) {
                                if (r) r.error("Error parsing " + o + " on " + e.className + ": " + t);
                                return;
                            }
                            var a = new t(e, s);
                            if (u) u.data(e, i, a);
                        });
                    });
                };
                return n;
            });
        },
        459: function (t, e, i) {
            var n, s, r;
            (function (o, a) {
                if (true) !((s = [i(707), i(664)]), (n = a), (r = "function" === typeof n ? n.apply(e, s) : n), void 0 !== r && (t.exports = r));
            })(window, function t(e, i) {
                "use strict";
                e.createMethods.push("_createAsNavFor");
                var n = e.prototype;
                n._createAsNavFor = function () {
                    this.on("activate", this.activateAsNavFor);
                    this.on("deactivate", this.deactivateAsNavFor);
                    this.on("destroy", this.destroyAsNavFor);
                    var t = this.options.asNavFor;
                    if (!t) return;
                    var e = this;
                    setTimeout(function i() {
                        e.setNavCompanion(t);
                    });
                };
                n.setNavCompanion = function (t) {
                    t = i.getQueryElement(t);
                    var n = e.data(t);
                    if (!n || n == this) return;
                    this.navCompanion = n;
                    var s = this;
                    this.onNavCompanionSelect = function () {
                        s.navCompanionSelect();
                    };
                    n.on("select", this.onNavCompanionSelect);
                    this.on("staticClick", this.onNavStaticClick);
                    this.navCompanionSelect(true);
                };
                n.navCompanionSelect = function (t) {
                    if (!this.navCompanion) return;
                    var e = this.navCompanion.selectedCells[0];
                    var i = this.navCompanion.cells.indexOf(e);
                    var n = i + this.navCompanion.selectedCells.length - 1;
                    var r = Math.floor(s(i, n, this.navCompanion.cellAlign));
                    this.selectCell(r, false, t);
                    this.removeNavSelectedElements();
                    if (r >= this.cells.length) return;
                    var o = this.cells.slice(i, n + 1);
                    this.navSelectedElements = o.map(function (t) {
                        return t.element;
                    });
                    this.changeNavSelectedClass("add");
                };
                function s(t, e, i) {
                    return (e - t) * i + t;
                }
                n.changeNavSelectedClass = function (t) {
                    this.navSelectedElements.forEach(function (e) {
                        e.classList[t]("is-nav-selected");
                    });
                };
                n.activateAsNavFor = function () {
                    this.navCompanionSelect(true);
                };
                n.removeNavSelectedElements = function () {
                    if (!this.navSelectedElements) return;
                    this.changeNavSelectedClass("remove");
                    delete this.navSelectedElements;
                };
                n.onNavStaticClick = function (t, e, i, n) {
                    if ("number" == typeof n) this.navCompanion.selectCell(n);
                };
                n.deactivateAsNavFor = function () {
                    this.removeNavSelectedElements();
                };
                n.destroyAsNavFor = function () {
                    if (!this.navCompanion) return;
                    this.navCompanion.off("select", this.onNavCompanionSelect);
                    this.off("staticClick", this.onNavStaticClick);
                    delete this.navCompanion;
                };
                return e;
            });
        },
        364: function (t, e, i) {
            var n, s, r;
            (function (o, a) {
                if (true) !((s = [i(707), i(664)]), (n = a), (r = "function" === typeof n ? n.apply(e, s) : n), void 0 !== r && (t.exports = r));
            })(this, function t(e, i) {
                var n = e.Slide;
                var s = n.prototype.updateTarget;
                n.prototype.updateTarget = function () {
                    s.apply(this, arguments);
                    if (!this.parent.options.fade) return;
                    var t = this.target - this.x;
                    var e = this.cells[0].x;
                    this.cells.forEach(function (i) {
                        var n = i.x - e - t;
                        i.renderPosition(n);
                    });
                };
                n.prototype.setOpacity = function (t) {
                    this.cells.forEach(function (e) {
                        e.element.style.opacity = t;
                    });
                };
                var r = e.prototype;
                e.createMethods.push("_createFade");
                r._createFade = function () {
                    this.fadeIndex = this.selectedIndex;
                    this.prevSelectedIndex = this.selectedIndex;
                    this.on("select", this.onSelectFade);
                    this.on("dragEnd", this.onDragEndFade);
                    this.on("settle", this.onSettleFade);
                    this.on("activate", this.onActivateFade);
                    this.on("deactivate", this.onDeactivateFade);
                };
                var o = r.updateSlides;
                r.updateSlides = function () {
                    o.apply(this, arguments);
                    if (!this.options.fade) return;
                    this.slides.forEach(function (t, e) {
                        var i = e == this.selectedIndex ? 1 : 0;
                        t.setOpacity(i);
                    }, this);
                };
                r.onSelectFade = function () {
                    this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
                    this.prevSelectedIndex = this.selectedIndex;
                };
                r.onSettleFade = function () {
                    delete this.didDragEnd;
                    if (!this.options.fade) return;
                    this.selectedSlide.setOpacity(1);
                    var t = this.slides[this.fadeIndex];
                    if (t && this.fadeIndex != this.selectedIndex) this.slides[this.fadeIndex].setOpacity(0);
                };
                r.onDragEndFade = function () {
                    this.didDragEnd = true;
                };
                r.onActivateFade = function () {
                    if (this.options.fade) this.element.classList.add("is-fade");
                };
                r.onDeactivateFade = function () {
                    if (!this.options.fade) return;
                    this.element.classList.remove("is-fade");
                    this.slides.forEach(function (t) {
                        t.setOpacity("");
                    });
                };
                var a = r.positionSlider;
                r.positionSlider = function () {
                    if (!this.options.fade) {
                        a.apply(this, arguments);
                        return;
                    }
                    this.fadeSlides();
                    this.dispatchScrollEvent();
                };
                var l = r.positionSliderAtSelected;
                r.positionSliderAtSelected = function () {
                    if (this.options.fade) this.setTranslateX(0);
                    l.apply(this, arguments);
                };
                r.fadeSlides = function () {
                    if (this.slides.length < 2) return;
                    var t = this.getFadeIndexes();
                    var e = this.slides[t.a];
                    var i = this.slides[t.b];
                    var n = this.wrapDifference(e.target, i.target);
                    var s = this.wrapDifference(e.target, -this.x);
                    s /= n;
                    e.setOpacity(1 - s);
                    i.setOpacity(s);
                    var r = t.a;
                    if (this.isDragging) r = s > 0.5 ? t.a : t.b;
                    var o = void 0 != this.fadeHideIndex && this.fadeHideIndex != r && this.fadeHideIndex != t.a && this.fadeHideIndex != t.b;
                    if (o) this.slides[this.fadeHideIndex].setOpacity(0);
                    this.fadeHideIndex = r;
                };
                r.getFadeIndexes = function () {
                    if (!this.isDragging && !this.didDragEnd) return { a: this.fadeIndex, b: this.selectedIndex };
                    if (this.options.wrapAround) return this.getFadeDragWrapIndexes();
                    else return this.getFadeDragLimitIndexes();
                };
                r.getFadeDragWrapIndexes = function () {
                    var t = this.slides.map(function (t, e) {
                        return this.getSlideDistance(-this.x, e);
                    }, this);
                    var e = t.map(function (t) {
                        return Math.abs(t);
                    });
                    var n = Math.min.apply(Math, e);
                    var s = e.indexOf(n);
                    var r = t[s];
                    var o = this.slides.length;
                    var a = r >= 0 ? 1 : -1;
                    return { a: s, b: i.modulo(s + a, o) };
                };
                r.getFadeDragLimitIndexes = function () {
                    var t = 0;
                    for (var e = 0; e < this.slides.length - 1; e++) {
                        var i = this.slides[e];
                        if (-this.x < i.target) break;
                        t = e;
                    }
                    return { a: t, b: t + 1 };
                };
                r.wrapDifference = function (t, e) {
                    var i = e - t;
                    if (!this.options.wrapAround) return i;
                    var n = i + this.slideableWidth;
                    var s = i - this.slideableWidth;
                    if (Math.abs(n) < Math.abs(i)) i = n;
                    if (Math.abs(s) < Math.abs(i)) i = s;
                    return i;
                };
                var h = r._getWrapShiftCells;
                r._getWrapShiftCells = function () {
                    if (!this.options.fade) h.apply(this, arguments);
                };
                var c = r.shiftWrapCells;
                r.shiftWrapCells = function () {
                    if (!this.options.fade) c.apply(this, arguments);
                };
                return e;
            });
        },
        883: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(5), i(664)]),
                    (s = function (t, e) {
                        return o(r, t, e);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i, n) {
                "use strict";
                function s(t) {
                    var e = document.createDocumentFragment();
                    t.forEach(function (t) {
                        e.appendChild(t.element);
                    });
                    return e;
                }
                var r = i.prototype;
                r.insert = function (t, e) {
                    var i = this._makeCells(t);
                    if (!i || !i.length) return;
                    var n = this.cells.length;
                    e = void 0 === e ? n : e;
                    var r = s(i);
                    var o = e == n;
                    if (o) this.slider.appendChild(r);
                    else {
                        var a = this.cells[e].element;
                        this.slider.insertBefore(r, a);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (o) this.cells = this.cells.concat(i);
                    else {
                        var l = this.cells.splice(e, n - e);
                        this.cells = this.cells.concat(i).concat(l);
                    }
                    this._sizeCells(i);
                    this.cellChange(e, true);
                };
                r.append = function (t) {
                    this.insert(t, this.cells.length);
                };
                r.prepend = function (t) {
                    this.insert(t, 0);
                };
                r.remove = function (t) {
                    var e = this.getCells(t);
                    if (!e || !e.length) return;
                    var i = this.cells.length - 1;
                    e.forEach(function (t) {
                        t.remove();
                        var e = this.cells.indexOf(t);
                        i = Math.min(e, i);
                        n.removeFrom(this.cells, t);
                    }, this);
                    this.cellChange(i, true);
                };
                r.cellSizeChange = function (t) {
                    var e = this.getCell(t);
                    if (!e) return;
                    e.getSize();
                    var i = this.cells.indexOf(e);
                    this.cellChange(i);
                };
                r.cellChange = function (t, e) {
                    var i = this.selectedElement;
                    this._positionCells(t);
                    this._getWrapShiftCells();
                    this.setGallerySize();
                    var n = this.getCell(i);
                    if (n) this.selectedIndex = this.getCellSlideIndex(n);
                    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
                    this.emitEvent("cellChange", [t]);
                    this.select(this.selectedIndex);
                    if (e) this.positionSliderAtSelected();
                };
                return i;
            });
        },
        21: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(664)]),
                    (s = function (t) {
                        return o(r, t);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i) {
                "use strict";
                var n = {};
                n.startAnimation = function () {
                    if (this.isAnimating) return;
                    this.isAnimating = true;
                    this.restingFrames = 0;
                    this.animate();
                };
                n.animate = function () {
                    this.applyDragForce();
                    this.applySelectedAttraction();
                    var t = this.x;
                    this.integratePhysics();
                    this.positionSlider();
                    this.settle(t);
                    if (this.isAnimating) {
                        var e = this;
                        requestAnimationFrame(function t() {
                            e.animate();
                        });
                    }
                };
                n.positionSlider = function () {
                    var t = this.x;
                    if (this.options.wrapAround && this.cells.length > 1) {
                        t = i.modulo(t, this.slideableWidth);
                        t -= this.slideableWidth;
                        this.shiftWrapCells(t);
                    }
                    this.setTranslateX(t, this.isAnimating);
                    this.dispatchScrollEvent();
                };
                n.setTranslateX = function (t, e) {
                    t += this.cursorPosition;
                    t = this.options.rightToLeft ? -t : t;
                    var i = this.getPositionValue(t);
                    this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
                };
                n.dispatchScrollEvent = function () {
                    var t = this.slides[0];
                    if (!t) return;
                    var e = -this.x - t.target;
                    var i = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i, e]);
                };
                n.positionSliderAtSelected = function () {
                    if (!this.cells.length) return;
                    this.x = -this.selectedSlide.target;
                    this.velocity = 0;
                    this.positionSlider();
                };
                n.getPositionValue = function (t) {
                    if (this.options.percentPosition) return 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%";
                    else return Math.round(t) + "px";
                };
                n.settle = function (t) {
                    var e = !this.isPointerDown && Math.round(100 * this.x) == Math.round(100 * t);
                    if (e) this.restingFrames++;
                    if (this.restingFrames > 2) {
                        this.isAnimating = false;
                        delete this.isFreeScrolling;
                        this.positionSlider();
                        this.dispatchEvent("settle", null, [this.selectedIndex]);
                    }
                };
                n.shiftWrapCells = function (t) {
                    var e = this.cursorPosition + t;
                    this._shiftCells(this.beforeShiftCells, e, -1);
                    var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, i, 1);
                };
                n._shiftCells = function (t, e, i) {
                    for (var n = 0; n < t.length; n++) {
                        var s = t[n];
                        var r = e > 0 ? i : 0;
                        s.wrapShift(r);
                        e -= s.size.outerWidth;
                    }
                };
                n._unshiftCells = function (t) {
                    if (!t || !t.length) return;
                    for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
                };
                n.integratePhysics = function () {
                    this.x += this.velocity;
                    this.velocity *= this.getFrictionFactor();
                };
                n.applyForce = function (t) {
                    this.velocity += t;
                };
                n.getFrictionFactor = function () {
                    return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
                };
                n.getRestingPosition = function () {
                    return this.x + this.velocity / (1 - this.getFrictionFactor());
                };
                n.applyDragForce = function () {
                    if (!this.isDraggable || !this.isPointerDown) return;
                    var t = this.dragX - this.x;
                    var e = t - this.velocity;
                    this.applyForce(e);
                };
                n.applySelectedAttraction = function () {
                    var t = this.isDraggable && this.isPointerDown;
                    if (t || this.isFreeScrolling || !this.slides.length) return;
                    var e = -1 * this.selectedSlide.target - this.x;
                    var i = e * this.options.selectedAttraction;
                    this.applyForce(i);
                };
                return n;
            });
        },
        195: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(768)]),
                    (s = function (t) {
                        return o(r, t);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i) {
                "use strict";
                function n(t, e) {
                    this.element = t;
                    this.parent = e;
                    this.create();
                }
                var s = n.prototype;
                s.create = function () {
                    this.element.style.position = "absolute";
                    this.element.setAttribute("aria-hidden", "true");
                    this.x = 0;
                    this.shift = 0;
                    this.element.style[this.parent.originSide] = 0;
                };
                s.destroy = function () {
                    this.unselect();
                    this.element.style.position = "";
                    var t = this.parent.originSide;
                    this.element.style[t] = "";
                    this.element.style.transform = "";
                    this.element.removeAttribute("aria-hidden");
                };
                s.getSize = function () {
                    this.size = i(this.element);
                };
                s.setPosition = function (t) {
                    this.x = t;
                    this.updateTarget();
                    this.renderPosition(t);
                };
                s.updateTarget = s.setDefaultTarget = function () {
                    var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                    this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign;
                };
                s.renderPosition = function (t) {
                    var e = "left" === this.parent.originSide ? 1 : -1;
                    var i = this.parent.options.percentPosition ? t * e * (this.parent.size.innerWidth / this.size.width) : t * e;
                    this.element.style.transform = "translateX(" + this.parent.getPositionValue(i) + ")";
                };
                s.select = function () {
                    this.element.classList.add("is-selected");
                    this.element.removeAttribute("aria-hidden");
                };
                s.unselect = function () {
                    this.element.classList.remove("is-selected");
                    this.element.setAttribute("aria-hidden", "true");
                };
                s.wrapShift = function (t) {
                    this.shift = t;
                    this.renderPosition(this.x + this.parent.slideableWidth * t);
                };
                s.remove = function () {
                    this.element.parentNode.removeChild(this.element);
                };
                return n;
            });
        },
        769: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(5), i(385), i(664)]),
                    (s = function (t, e, i) {
                        return o(r, t, e, i);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i, n, s) {
                "use strict";
                s.extend(i.defaults, { draggable: ">1", dragThreshold: 3 });
                i.createMethods.push("_createDrag");
                var r = i.prototype;
                s.extend(r, n.prototype);
                r._touchActionValue = "pan-y";
                r._createDrag = function () {
                    this.on("activate", this.onActivateDrag);
                    this.on("uiChange", this._uiChangeDrag);
                    this.on("deactivate", this.onDeactivateDrag);
                    this.on("cellChange", this.updateDraggable);
                };
                r.onActivateDrag = function () {
                    this.handles = [this.viewport];
                    this.bindHandles();
                    this.updateDraggable();
                };
                r.onDeactivateDrag = function () {
                    this.unbindHandles();
                    this.element.classList.remove("is-draggable");
                };
                r.updateDraggable = function () {
                    if (">1" == this.options.draggable) this.isDraggable = this.slides.length > 1;
                    else this.isDraggable = this.options.draggable;
                    if (this.isDraggable) this.element.classList.add("is-draggable");
                    else this.element.classList.remove("is-draggable");
                };
                r.bindDrag = function () {
                    this.options.draggable = true;
                    this.updateDraggable();
                };
                r.unbindDrag = function () {
                    this.options.draggable = false;
                    this.updateDraggable();
                };
                r._uiChangeDrag = function () {
                    delete this.isFreeScrolling;
                };
                r.pointerDown = function (t, i) {
                    if (!this.isDraggable) {
                        this._pointerDownDefault(t, i);
                        return;
                    }
                    var n = this.okayPointerDown(t);
                    if (!n) return;
                    this._pointerDownPreventDefault(t);
                    this.pointerDownFocus(t);
                    if (document.activeElement != this.element) this.pointerDownBlur();
                    this.dragX = this.x;
                    this.viewport.classList.add("is-pointer-down");
                    this.pointerDownScroll = a();
                    e.addEventListener("scroll", this);
                    this._pointerDownDefault(t, i);
                };
                r._pointerDownDefault = function (t, e) {
                    this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY };
                    this._bindPostStartEvents(t);
                    this.dispatchEvent("pointerDown", t, [e]);
                };
                var o = { INPUT: true, TEXTAREA: true, SELECT: true };
                r.pointerDownFocus = function (t) {
                    var e = o[t.target.nodeName];
                    if (!e) this.focus();
                };
                r._pointerDownPreventDefault = function (t) {
                    var e = "touchstart" == t.type;
                    var i = "touch" == t.pointerType;
                    var n = o[t.target.nodeName];
                    if (!e && !i && !n) t.preventDefault();
                };
                r.hasDragStarted = function (t) {
                    return Math.abs(t.x) > this.options.dragThreshold;
                };
                r.pointerUp = function (t, e) {
                    delete this.isTouchScrolling;
                    this.viewport.classList.remove("is-pointer-down");
                    this.dispatchEvent("pointerUp", t, [e]);
                    this._dragPointerUp(t, e);
                };
                r.pointerDone = function () {
                    e.removeEventListener("scroll", this);
                    delete this.pointerDownScroll;
                };
                r.dragStart = function (t, i) {
                    if (!this.isDraggable) return;
                    this.dragStartPosition = this.x;
                    this.startAnimation();
                    e.removeEventListener("scroll", this);
                    this.dispatchEvent("dragStart", t, [i]);
                };
                r.pointerMove = function (t, e) {
                    var i = this._dragPointerMove(t, e);
                    this.dispatchEvent("pointerMove", t, [e, i]);
                    this._dragMove(t, e, i);
                };
                r.dragMove = function (t, e, i) {
                    if (!this.isDraggable) return;
                    t.preventDefault();
                    this.previousDragX = this.dragX;
                    var n = this.options.rightToLeft ? -1 : 1;
                    if (this.options.wrapAround) i.x %= this.slideableWidth;
                    var s = this.dragStartPosition + i.x * n;
                    if (!this.options.wrapAround && this.slides.length) {
                        var r = Math.max(-this.slides[0].target, this.dragStartPosition);
                        s = s > r ? 0.5 * (s + r) : s;
                        var o = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                        s = s < o ? 0.5 * (s + o) : s;
                    }
                    this.dragX = s;
                    this.dragMoveTime = new Date();
                    this.dispatchEvent("dragMove", t, [e, i]);
                };
                r.dragEnd = function (t, e) {
                    if (!this.isDraggable) return;
                    if (this.options.freeScroll) this.isFreeScrolling = true;
                    var i = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                        var n = this.getRestingPosition();
                        this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
                    } else if (!this.options.freeScroll && i == this.selectedIndex) i += this.dragEndBoostSelect();
                    delete this.previousDragX;
                    this.isDragSelect = this.options.wrapAround;
                    this.select(i);
                    delete this.isDragSelect;
                    this.dispatchEvent("dragEnd", t, [e]);
                };
                r.dragEndRestingSelect = function () {
                    var t = this.getRestingPosition();
                    var e = Math.abs(this.getSlideDistance(-t, this.selectedIndex));
                    var i = this._getClosestResting(t, e, 1);
                    var n = this._getClosestResting(t, e, -1);
                    var s = i.distance < n.distance ? i.index : n.index;
                    return s;
                };
                r._getClosestResting = function (t, e, i) {
                    var n = this.selectedIndex;
                    var s = 1 / 0;
                    var r =
                        this.options.contain && !this.options.wrapAround
                            ? function (t, e) {
                                  return t <= e;
                              }
                            : function (t, e) {
                                  return t < e;
                              };
                    while (r(e, s)) {
                        n += i;
                        s = e;
                        e = this.getSlideDistance(-t, n);
                        if (null === e) break;
                        e = Math.abs(e);
                    }
                    return { distance: s, index: n - i };
                };
                r.getSlideDistance = function (t, e) {
                    var i = this.slides.length;
                    var n = this.options.wrapAround && i > 1;
                    var r = n ? s.modulo(e, i) : e;
                    var o = this.slides[r];
                    if (!o) return null;
                    var a = n ? this.slideableWidth * Math.floor(e / i) : 0;
                    return t - (o.target + a);
                };
                r.dragEndBoostSelect = function () {
                    if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                    var t = this.getSlideDistance(-this.dragX, this.selectedIndex);
                    var e = this.previousDragX - this.dragX;
                    if (t > 0 && e > 0) return 1;
                    else if (t < 0 && e < 0) return -1;
                    return 0;
                };
                r.staticClick = function (t, e) {
                    var i = this.getParentCell(t.target);
                    var n = i && i.element;
                    var s = i && this.cells.indexOf(i);
                    this.dispatchEvent("staticClick", t, [e, n, s]);
                };
                r.onscroll = function () {
                    var t = a();
                    var e = this.pointerDownScroll.x - t.x;
                    var i = this.pointerDownScroll.y - t.y;
                    if (Math.abs(e) > 3 || Math.abs(i) > 3) this._pointerDone();
                };
                function a() {
                    return { x: e.pageXOffset, y: e.pageYOffset };
                }
                return i;
            });
        },
        5: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(323), i(768), i(664), i(195), i(861), i(21)]),
                    (s = function (t, e, i, n, s, a) {
                        return o(r, t, e, i, n, s, a);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
                else var a;
            })(window, function t(e, i, n, s, r, o, a) {
                "use strict";
                var l = e.jQuery;
                var h = e.getComputedStyle;
                var c = e.console;
                function u(t, e) {
                    t = s.makeArray(t);
                    while (t.length) e.appendChild(t.shift());
                }
                var d = 0;
                var f = {};
                function p(t, e) {
                    var i = s.getQueryElement(t);
                    if (!i) {
                        if (c) c.error("Bad element for Flickity: " + (i || t));
                        return;
                    }
                    this.element = i;
                    if (this.element.flickityGUID) {
                        var n = f[this.element.flickityGUID];
                        if (n) n.option(e);
                        return n;
                    }
                    if (l) this.$element = l(this.element);
                    this.options = s.extend({}, this.constructor.defaults);
                    this.option(e);
                    this._create();
                }
                p.defaults = { accessibility: true, cellAlign: "center", freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: true, percentPosition: true, resize: true, selectedAttraction: 0.025, setGallerySize: true };
                p.createMethods = [];
                var v = p.prototype;
                s.extend(v, i.prototype);
                v._create = function () {
                    var t = (this.guid = ++d);
                    this.element.flickityGUID = t;
                    f[t] = this;
                    this.selectedIndex = 0;
                    this.restingFrames = 0;
                    this.x = 0;
                    this.velocity = 0;
                    this.originSide = this.options.rightToLeft ? "right" : "left";
                    this.viewport = document.createElement("div");
                    this.viewport.className = "flickity-viewport";
                    this._createSlider();
                    if (this.options.resize || this.options.watchCSS) e.addEventListener("resize", this);
                    for (var i in this.options.on) {
                        var n = this.options.on[i];
                        this.on(i, n);
                    }
                    p.createMethods.forEach(function (t) {
                        this[t]();
                    }, this);
                    if (this.options.watchCSS) this.watchCSS();
                    else this.activate();
                };
                v.option = function (t) {
                    s.extend(this.options, t);
                };
                v.activate = function () {
                    if (this.isActive) return;
                    this.isActive = true;
                    this.element.classList.add("flickity-enabled");
                    if (this.options.rightToLeft) this.element.classList.add("flickity-rtl");
                    this.getSize();
                    var t = this._filterFindCellElements(this.element.children);
                    u(t, this.slider);
                    this.viewport.appendChild(this.slider);
                    this.element.appendChild(this.viewport);
                    this.reloadCells();
                    if (this.options.accessibility) {
                        this.element.tabIndex = 0;
                        this.element.addEventListener("keydown", this);
                    }
                    this.emitEvent("activate");
                    this.selectInitialIndex();
                    this.isInitActivated = true;
                    this.dispatchEvent("ready");
                };
                v._createSlider = function () {
                    var t = document.createElement("div");
                    t.className = "flickity-slider";
                    t.style[this.originSide] = 0;
                    this.slider = t;
                };
                v._filterFindCellElements = function (t) {
                    return s.filterFindElements(t, this.options.cellSelector);
                };
                v.reloadCells = function () {
                    this.cells = this._makeCells(this.slider.children);
                    this.positionCells();
                    this._getWrapShiftCells();
                    this.setGallerySize();
                };
                v._makeCells = function (t) {
                    var e = this._filterFindCellElements(t);
                    var i = e.map(function (t) {
                        return new r(t, this);
                    }, this);
                    return i;
                };
                v.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                };
                v.getLastSlide = function () {
                    return this.slides[this.slides.length - 1];
                };
                v.positionCells = function () {
                    this._sizeCells(this.cells);
                    this._positionCells(0);
                };
                v._positionCells = function (t) {
                    t = t || 0;
                    this.maxCellHeight = t ? this.maxCellHeight || 0 : 0;
                    var e = 0;
                    if (t > 0) {
                        var i = this.cells[t - 1];
                        e = i.x + i.size.outerWidth;
                    }
                    var n = this.cells.length;
                    for (var s = t; s < n; s++) {
                        var r = this.cells[s];
                        r.setPosition(e);
                        e += r.size.outerWidth;
                        this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight);
                    }
                    this.slideableWidth = e;
                    this.updateSlides();
                    this._containSlides();
                    this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0;
                };
                v._sizeCells = function (t) {
                    t.forEach(function (t) {
                        t.getSize();
                    });
                };
                v.updateSlides = function () {
                    this.slides = [];
                    if (!this.cells.length) return;
                    var t = new o(this);
                    this.slides.push(t);
                    var e = "left" == this.originSide;
                    var i = e ? "marginRight" : "marginLeft";
                    var n = this._getCanCellFit();
                    this.cells.forEach(function (e, s) {
                        if (!t.cells.length) {
                            t.addCell(e);
                            return;
                        }
                        var r = t.outerWidth - t.firstMargin + (e.size.outerWidth - e.size[i]);
                        if (n.call(this, s, r)) t.addCell(e);
                        else {
                            t.updateTarget();
                            t = new o(this);
                            this.slides.push(t);
                            t.addCell(e);
                        }
                    }, this);
                    t.updateTarget();
                    this.updateSelectedSlide();
                };
                v._getCanCellFit = function () {
                    var t = this.options.groupCells;
                    if (!t)
                        return function () {
                            return false;
                        };
                    else if ("number" == typeof t) {
                        var e = parseInt(t, 10);
                        return function (t) {
                            return t % e !== 0;
                        };
                    }
                    var i = "string" == typeof t && t.match(/^(\d+)%$/);
                    var n = i ? parseInt(i[1], 10) / 100 : 1;
                    return function (t, e) {
                        return e <= (this.size.innerWidth + 1) * n;
                    };
                };
                v._init = v.reposition = function () {
                    this.positionCells();
                    this.positionSliderAtSelected();
                };
                v.getSize = function () {
                    this.size = n(this.element);
                    this.setCellAlign();
                    this.cursorPosition = this.size.innerWidth * this.cellAlign;
                };
                var g = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
                v.setCellAlign = function () {
                    var t = g[this.options.cellAlign];
                    this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
                };
                v.setGallerySize = function () {
                    if (this.options.setGallerySize) {
                        var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                        this.viewport.style.height = t + "px";
                    }
                };
                v._getWrapShiftCells = function () {
                    if (!this.options.wrapAround) return;
                    this._unshiftCells(this.beforeShiftCells);
                    this._unshiftCells(this.afterShiftCells);
                    var t = this.cursorPosition;
                    var e = this.cells.length - 1;
                    this.beforeShiftCells = this._getGapCells(t, e, -1);
                    t = this.size.innerWidth - this.cursorPosition;
                    this.afterShiftCells = this._getGapCells(t, 0, 1);
                };
                v._getGapCells = function (t, e, i) {
                    var n = [];
                    while (t > 0) {
                        var s = this.cells[e];
                        if (!s) break;
                        n.push(s);
                        e += i;
                        t -= s.size.outerWidth;
                    }
                    return n;
                };
                v._containSlides = function () {
                    if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
                    var t = this.options.rightToLeft;
                    var e = t ? "marginRight" : "marginLeft";
                    var i = t ? "marginLeft" : "marginRight";
                    var n = this.slideableWidth - this.getLastCell().size[i];
                    var s = n < this.size.innerWidth;
                    var r = this.cursorPosition + this.cells[0].size[e];
                    var o = n - this.size.innerWidth * (1 - this.cellAlign);
                    this.slides.forEach(function (t) {
                        if (s) t.target = n * this.cellAlign;
                        else {
                            t.target = Math.max(t.target, r);
                            t.target = Math.min(t.target, o);
                        }
                    }, this);
                };
                v.dispatchEvent = function (t, e, i) {
                    var n = e ? [e].concat(i) : i;
                    this.emitEvent(t, n);
                    if (l && this.$element) {
                        t += this.options.namespaceJQueryEvents ? ".flickity" : "";
                        var s = t;
                        if (e) {
                            var r = new l.Event(e);
                            r.type = t;
                            s = r;
                        }
                        this.$element.trigger(s, i);
                    }
                };
                v.select = function (t, e, i) {
                    if (!this.isActive) return;
                    t = parseInt(t, 10);
                    this._wrapSelect(t);
                    if (this.options.wrapAround || e) t = s.modulo(t, this.slides.length);
                    if (!this.slides[t]) return;
                    var n = this.selectedIndex;
                    this.selectedIndex = t;
                    this.updateSelectedSlide();
                    if (i) this.positionSliderAtSelected();
                    else this.startAnimation();
                    if (this.options.adaptiveHeight) this.setGallerySize();
                    this.dispatchEvent("select", null, [t]);
                    if (t != n) this.dispatchEvent("change", null, [t]);
                    this.dispatchEvent("cellSelect");
                };
                v._wrapSelect = function (t) {
                    var e = this.slides.length;
                    var i = this.options.wrapAround && e > 1;
                    if (!i) return t;
                    var n = s.modulo(t, e);
                    var r = Math.abs(n - this.selectedIndex);
                    var o = Math.abs(n + e - this.selectedIndex);
                    var a = Math.abs(n - e - this.selectedIndex);
                    if (!this.isDragSelect && o < r) t += e;
                    else if (!this.isDragSelect && a < r) t -= e;
                    if (t < 0) this.x -= this.slideableWidth;
                    else if (t >= e) this.x += this.slideableWidth;
                };
                v.previous = function (t, e) {
                    this.select(this.selectedIndex - 1, t, e);
                };
                v.next = function (t, e) {
                    this.select(this.selectedIndex + 1, t, e);
                };
                v.updateSelectedSlide = function () {
                    var t = this.slides[this.selectedIndex];
                    if (!t) return;
                    this.unselectSelectedSlide();
                    this.selectedSlide = t;
                    t.select();
                    this.selectedCells = t.cells;
                    this.selectedElements = t.getCellElements();
                    this.selectedCell = t.cells[0];
                    this.selectedElement = this.selectedElements[0];
                };
                v.unselectSelectedSlide = function () {
                    if (this.selectedSlide) this.selectedSlide.unselect();
                };
                v.selectInitialIndex = function () {
                    var t = this.options.initialIndex;
                    if (this.isInitActivated) {
                        this.select(this.selectedIndex, false, true);
                        return;
                    }
                    if (t && "string" == typeof t) {
                        var e = this.queryCell(t);
                        if (e) {
                            this.selectCell(t, false, true);
                            return;
                        }
                    }
                    var i = 0;
                    if (t && this.slides[t]) i = t;
                    this.select(i, false, true);
                };
                v.selectCell = function (t, e, i) {
                    var n = this.queryCell(t);
                    if (!n) return;
                    var s = this.getCellSlideIndex(n);
                    this.select(s, e, i);
                };
                v.getCellSlideIndex = function (t) {
                    for (var e = 0; e < this.slides.length; e++) {
                        var i = this.slides[e];
                        var n = i.cells.indexOf(t);
                        if (-1 != n) return e;
                    }
                };
                v.getCell = function (t) {
                    for (var e = 0; e < this.cells.length; e++) {
                        var i = this.cells[e];
                        if (i.element == t) return i;
                    }
                };
                v.getCells = function (t) {
                    t = s.makeArray(t);
                    var e = [];
                    t.forEach(function (t) {
                        var i = this.getCell(t);
                        if (i) e.push(i);
                    }, this);
                    return e;
                };
                v.getCellElements = function () {
                    return this.cells.map(function (t) {
                        return t.element;
                    });
                };
                v.getParentCell = function (t) {
                    var e = this.getCell(t);
                    if (e) return e;
                    t = s.getParent(t, ".flickity-slider > *");
                    return this.getCell(t);
                };
                v.getAdjacentCellElements = function (t, e) {
                    if (!t) return this.selectedSlide.getCellElements();
                    e = void 0 === e ? this.selectedIndex : e;
                    var i = this.slides.length;
                    if (1 + 2 * t >= i) return this.getCellElements();
                    var n = [];
                    for (var r = e - t; r <= e + t; r++) {
                        var o = this.options.wrapAround ? s.modulo(r, i) : r;
                        var a = this.slides[o];
                        if (a) n = n.concat(a.getCellElements());
                    }
                    return n;
                };
                v.queryCell = function (t) {
                    if ("number" == typeof t) return this.cells[t];
                    if ("string" == typeof t) {
                        if (t.match(/^[#.]?[\d/]/)) return;
                        t = this.element.querySelector(t);
                    }
                    return this.getCell(t);
                };
                v.uiChange = function () {
                    this.emitEvent("uiChange");
                };
                v.childUIPointerDown = function (t) {
                    if ("touchstart" != t.type) t.preventDefault();
                    this.focus();
                };
                v.onresize = function () {
                    this.watchCSS();
                    this.resize();
                };
                s.debounceMethod(p, "onresize", 150);
                v.resize = function () {
                    if (!this.isActive || this.isAnimating || this.isDragging) return;
                    this.getSize();
                    if (this.options.wrapAround) this.x = s.modulo(this.x, this.slideableWidth);
                    this.positionCells();
                    this._getWrapShiftCells();
                    this.setGallerySize();
                    this.emitEvent("resize");
                    var t = this.selectedElements && this.selectedElements[0];
                    this.selectCell(t, false, true);
                };
                v.watchCSS = function () {
                    var t = this.options.watchCSS;
                    if (!t) return;
                    var e = h(this.element, ":after").content;
                    if (-1 != e.indexOf("flickity")) this.activate();
                    else this.deactivate();
                };
                v.onkeydown = function (t) {
                    var e = document.activeElement && document.activeElement != this.element;
                    if (!this.options.accessibility || e) return;
                    var i = p.keyboardHandlers[t.keyCode];
                    if (i) i.call(this);
                };
                p.keyboardHandlers = {
                    37: function () {
                        var t = this.options.rightToLeft ? "next" : "previous";
                        this.uiChange();
                        this[t]();
                    },
                    39: function () {
                        var t = this.options.rightToLeft ? "previous" : "next";
                        this.uiChange();
                        this[t]();
                    },
                };
                v.focus = function () {
                    var t = e.pageYOffset;
                    this.element.focus({ preventScroll: true });
                    if (e.pageYOffset != t) e.scrollTo(e.pageXOffset, t);
                };
                v.deactivate = function () {
                    if (!this.isActive) return;
                    this.element.classList.remove("flickity-enabled");
                    this.element.classList.remove("flickity-rtl");
                    this.unselectSelectedSlide();
                    this.cells.forEach(function (t) {
                        t.destroy();
                    });
                    this.element.removeChild(this.viewport);
                    u(this.slider.children, this.element);
                    if (this.options.accessibility) {
                        this.element.removeAttribute("tabIndex");
                        this.element.removeEventListener("keydown", this);
                    }
                    this.isActive = false;
                    this.emitEvent("deactivate");
                };
                v.destroy = function () {
                    this.deactivate();
                    e.removeEventListener("resize", this);
                    this.allOff();
                    this.emitEvent("destroy");
                    if (l && this.$element) l.removeData(this.element, "flickity");
                    delete this.element.flickityGUID;
                    delete f[this.guid];
                };
                s.extend(v, a);
                p.data = function (t) {
                    t = s.getQueryElement(t);
                    var e = t && t.flickityGUID;
                    return e && f[e];
                };
                s.htmlInit(p, "flickity");
                if (l && l.bridget) l.bridget("flickity", p);
                p.setJQuery = function (t) {
                    l = t;
                };
                p.Cell = r;
                p.Slide = o;
                return p;
            });
        },
        707: function (t, e, i) {
            var n, s, r;
            (function (o, a) {
                if (true) !((s = [i(5), i(769), i(276), i(504), i(0), i(883), i(812)]), (n = a), (r = "function" === typeof n ? n.apply(e, s) : n), void 0 !== r && (t.exports = r));
            })(window, function t(e) {
                return e;
            });
        },
        812: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(5), i(664)]),
                    (s = function (t, e) {
                        return o(r, t, e);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i, n) {
                "use strict";
                i.createMethods.push("_createLazyload");
                var s = i.prototype;
                s._createLazyload = function () {
                    this.on("select", this.lazyLoad);
                };
                s.lazyLoad = function () {
                    var t = this.options.lazyLoad;
                    if (!t) return;
                    var e = "number" == typeof t ? t : 0;
                    var i = this.getAdjacentCellElements(e);
                    var n = [];
                    i.forEach(function (t) {
                        var e = r(t);
                        n = n.concat(e);
                    });
                    n.forEach(function (t) {
                        new o(t, this);
                    }, this);
                };
                function r(t) {
                    if ("IMG" == t.nodeName) {
                        var e = t.getAttribute("data-flickity-lazyload");
                        var i = t.getAttribute("data-flickity-lazyload-src");
                        var s = t.getAttribute("data-flickity-lazyload-srcset");
                        if (e || i || s) return [t];
                    }
                    var r = "img[data-flickity-lazyload], " + "img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
                    var o = t.querySelectorAll(r);
                    return n.makeArray(o);
                }
                function o(t, e) {
                    this.img = t;
                    this.flickity = e;
                    this.load();
                }
                o.prototype.handleEvent = n.handleEvent;
                o.prototype.load = function () {
                    this.img.addEventListener("load", this);
                    this.img.addEventListener("error", this);
                    var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src");
                    var e = this.img.getAttribute("data-flickity-lazyload-srcset");
                    this.img.src = t;
                    if (e) this.img.setAttribute("srcset", e);
                    this.img.removeAttribute("data-flickity-lazyload");
                    this.img.removeAttribute("data-flickity-lazyload-src");
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
                };
                o.prototype.onload = function (t) {
                    this.complete(t, "flickity-lazyloaded");
                };
                o.prototype.onerror = function (t) {
                    this.complete(t, "flickity-lazyerror");
                };
                o.prototype.complete = function (t, e) {
                    this.img.removeEventListener("load", this);
                    this.img.removeEventListener("error", this);
                    var i = this.flickity.getParentCell(this.img);
                    var n = i && i.element;
                    this.flickity.cellSizeChange(n);
                    this.img.classList.add(e);
                    this.flickity.dispatchEvent("lazyLoad", t, n);
                };
                i.LazyLoader = o;
                return i;
            });
        },
        504: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(5), i(497), i(664)]),
                    (s = function (t, e, i) {
                        return o(r, t, e, i);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i, n, s) {
                "use strict";
                function r(t) {
                    this.parent = t;
                    this._create();
                }
                r.prototype = Object.create(n.prototype);
                r.prototype._create = function () {
                    this.holder = document.createElement("ol");
                    this.holder.className = "flickity-page-dots";
                    this.dots = [];
                    this.handleClick = this.onClick.bind(this);
                    this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
                };
                r.prototype.activate = function () {
                    this.setDots();
                    this.holder.addEventListener("click", this.handleClick);
                    this.bindStartEvent(this.holder);
                    this.parent.element.appendChild(this.holder);
                };
                r.prototype.deactivate = function () {
                    this.holder.removeEventListener("click", this.handleClick);
                    this.unbindStartEvent(this.holder);
                    this.parent.element.removeChild(this.holder);
                };
                r.prototype.setDots = function () {
                    var t = this.parent.slides.length - this.dots.length;
                    if (t > 0) this.addDots(t);
                    else if (t < 0) this.removeDots(-t);
                };
                r.prototype.addDots = function (t) {
                    var e = document.createDocumentFragment();
                    var i = [];
                    var n = this.dots.length;
                    var s = n + t;
                    for (var r = n; r < s; r++) {
                        var o = document.createElement("li");
                        o.className = "dot";
                        o.setAttribute("aria-label", "Page dot " + (r + 1));
                        e.appendChild(o);
                        i.push(o);
                    }
                    this.holder.appendChild(e);
                    this.dots = this.dots.concat(i);
                };
                r.prototype.removeDots = function (t) {
                    var e = this.dots.splice(this.dots.length - t, t);
                    e.forEach(function (t) {
                        this.holder.removeChild(t);
                    }, this);
                };
                r.prototype.updateSelected = function () {
                    if (this.selectedDot) {
                        this.selectedDot.className = "dot";
                        this.selectedDot.removeAttribute("aria-current");
                    }
                    if (!this.dots.length) return;
                    this.selectedDot = this.dots[this.parent.selectedIndex];
                    this.selectedDot.className = "dot is-selected";
                    this.selectedDot.setAttribute("aria-current", "step");
                };
                r.prototype.onTap = r.prototype.onClick = function (t) {
                    var e = t.target;
                    if ("LI" != e.nodeName) return;
                    this.parent.uiChange();
                    var i = this.dots.indexOf(e);
                    this.parent.select(i);
                };
                r.prototype.destroy = function () {
                    this.deactivate();
                    this.allOff();
                };
                i.PageDots = r;
                s.extend(i.defaults, { pageDots: true });
                i.createMethods.push("_createPageDots");
                var o = i.prototype;
                o._createPageDots = function () {
                    if (!this.options.pageDots) return;
                    this.pageDots = new r(this);
                    this.on("activate", this.activatePageDots);
                    this.on("select", this.updateSelectedPageDots);
                    this.on("cellChange", this.updatePageDots);
                    this.on("resize", this.updatePageDots);
                    this.on("deactivate", this.deactivatePageDots);
                };
                o.activatePageDots = function () {
                    this.pageDots.activate();
                };
                o.updateSelectedPageDots = function () {
                    this.pageDots.updateSelected();
                };
                o.updatePageDots = function () {
                    this.pageDots.setDots();
                };
                o.deactivatePageDots = function () {
                    this.pageDots.deactivate();
                };
                i.PageDots = r;
                return i;
            });
        },
        0: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(323), i(664), i(5)]),
                    (s = function (t, e, i) {
                        return o(t, e, i);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i, n) {
                "use strict";
                function s(t) {
                    this.parent = t;
                    this.state = "stopped";
                    this.onVisibilityChange = this.visibilityChange.bind(this);
                    this.onVisibilityPlay = this.visibilityPlay.bind(this);
                }
                s.prototype = Object.create(e.prototype);
                s.prototype.play = function () {
                    if ("playing" == this.state) return;
                    var t = document.hidden;
                    if (t) {
                        document.addEventListener("visibilitychange", this.onVisibilityPlay);
                        return;
                    }
                    this.state = "playing";
                    document.addEventListener("visibilitychange", this.onVisibilityChange);
                    this.tick();
                };
                s.prototype.tick = function () {
                    if ("playing" != this.state) return;
                    var t = this.parent.options.autoPlay;
                    t = "number" == typeof t ? t : 3e3;
                    var e = this;
                    this.clear();
                    this.timeout = setTimeout(function () {
                        e.parent.next(true);
                        e.tick();
                    }, t);
                };
                s.prototype.stop = function () {
                    this.state = "stopped";
                    this.clear();
                    document.removeEventListener("visibilitychange", this.onVisibilityChange);
                };
                s.prototype.clear = function () {
                    clearTimeout(this.timeout);
                };
                s.prototype.pause = function () {
                    if ("playing" == this.state) {
                        this.state = "paused";
                        this.clear();
                    }
                };
                s.prototype.unpause = function () {
                    if ("paused" == this.state) this.play();
                };
                s.prototype.visibilityChange = function () {
                    var t = document.hidden;
                    this[t ? "pause" : "unpause"]();
                };
                s.prototype.visibilityPlay = function () {
                    this.play();
                    document.removeEventListener("visibilitychange", this.onVisibilityPlay);
                };
                i.extend(n.defaults, { pauseAutoPlayOnHover: true });
                n.createMethods.push("_createPlayer");
                var r = n.prototype;
                r._createPlayer = function () {
                    this.player = new s(this);
                    this.on("activate", this.activatePlayer);
                    this.on("uiChange", this.stopPlayer);
                    this.on("pointerDown", this.stopPlayer);
                    this.on("deactivate", this.deactivatePlayer);
                };
                r.activatePlayer = function () {
                    if (!this.options.autoPlay) return;
                    this.player.play();
                    this.element.addEventListener("mouseenter", this);
                };
                r.playPlayer = function () {
                    this.player.play();
                };
                r.stopPlayer = function () {
                    this.player.stop();
                };
                r.pausePlayer = function () {
                    this.player.pause();
                };
                r.unpausePlayer = function () {
                    this.player.unpause();
                };
                r.deactivatePlayer = function () {
                    this.player.stop();
                    this.element.removeEventListener("mouseenter", this);
                };
                r.onmouseenter = function () {
                    if (!this.options.pauseAutoPlayOnHover) return;
                    this.player.pause();
                    this.element.addEventListener("mouseleave", this);
                };
                r.onmouseleave = function () {
                    this.player.unpause();
                    this.element.removeEventListener("mouseleave", this);
                };
                n.Player = s;
                return n;
            });
        },
        276: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(5), i(497), i(664)]),
                    (s = function (t, e, i) {
                        return o(r, t, e, i);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i, n, s) {
                "use strict";
                var r = "http://www.w3.org/2000/svg";
                function o(t, e) {
                    this.direction = t;
                    this.parent = e;
                    this._create();
                }
                o.prototype = Object.create(n.prototype);
                o.prototype._create = function () {
                    this.isEnabled = true;
                    this.isPrevious = -1 == this.direction;
                    var t = this.parent.options.rightToLeft ? 1 : -1;
                    this.isLeft = this.direction == t;
                    var e = (this.element = document.createElement("button"));
                    e.className = "flickity-button flickity-prev-next-button";
                    e.className += this.isPrevious ? " previous" : " next";
                    e.setAttribute("type", "button");
                    this.disable();
                    e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                    var i = this.createSVG();
                    e.appendChild(i);
                    this.parent.on("select", this.update.bind(this));
                    this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
                };
                o.prototype.activate = function () {
                    this.bindStartEvent(this.element);
                    this.element.addEventListener("click", this);
                    this.parent.element.appendChild(this.element);
                };
                o.prototype.deactivate = function () {
                    this.parent.element.removeChild(this.element);
                    this.unbindStartEvent(this.element);
                    this.element.removeEventListener("click", this);
                };
                o.prototype.createSVG = function () {
                    var t = document.createElementNS(r, "svg");
                    t.setAttribute("class", "flickity-button-icon");
                    t.setAttribute("viewBox", "0 0 100 100");
                    var e = document.createElementNS(r, "path");
                    var i = a(this.parent.options.arrowShape);
                    e.setAttribute("d", i);
                    e.setAttribute("class", "arrow");
                    if (!this.isLeft) e.setAttribute("transform", "translate(100, 100) rotate(180) ");
                    t.appendChild(e);
                    return t;
                };
                function a(t) {
                    if ("string" == typeof t) return t;
                    return "M " + t.x0 + ",50" + " L " + t.x1 + "," + (t.y1 + 50) + " L " + t.x2 + "," + (t.y2 + 50) + " L " + t.x3 + ",50 " + " L " + t.x2 + "," + (50 - t.y2) + " L " + t.x1 + "," + (50 - t.y1) + " Z";
                }
                o.prototype.handleEvent = s.handleEvent;
                o.prototype.onclick = function () {
                    if (!this.isEnabled) return;
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                };
                o.prototype.enable = function () {
                    if (this.isEnabled) return;
                    this.element.disabled = false;
                    this.isEnabled = true;
                };
                o.prototype.disable = function () {
                    if (!this.isEnabled) return;
                    this.element.disabled = true;
                    this.isEnabled = false;
                };
                o.prototype.update = function () {
                    var t = this.parent.slides;
                    if (this.parent.options.wrapAround && t.length > 1) {
                        this.enable();
                        return;
                    }
                    var e = t.length ? t.length - 1 : 0;
                    var i = this.isPrevious ? 0 : e;
                    var n = this.parent.selectedIndex == i ? "disable" : "enable";
                    this[n]();
                };
                o.prototype.destroy = function () {
                    this.deactivate();
                    this.allOff();
                };
                s.extend(i.defaults, { prevNextButtons: true, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } });
                i.createMethods.push("_createPrevNextButtons");
                var l = i.prototype;
                l._createPrevNextButtons = function () {
                    if (!this.options.prevNextButtons) return;
                    this.prevButton = new o(-1, this);
                    this.nextButton = new o(1, this);
                    this.on("activate", this.activatePrevNextButtons);
                };
                l.activatePrevNextButtons = function () {
                    this.prevButton.activate();
                    this.nextButton.activate();
                    this.on("deactivate", this.deactivatePrevNextButtons);
                };
                l.deactivatePrevNextButtons = function () {
                    this.prevButton.deactivate();
                    this.nextButton.deactivate();
                    this.off("deactivate", this.deactivatePrevNextButtons);
                };
                i.PrevNextButton = o;
                return i;
            });
        },
        861: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true) !((n = o), (s = "function" === typeof n ? n.call(e, i, e, t) : n), void 0 !== s && (t.exports = s));
            })(window, function t() {
                "use strict";
                function e(t) {
                    this.parent = t;
                    this.isOriginLeft = "left" == t.originSide;
                    this.cells = [];
                    this.outerWidth = 0;
                    this.height = 0;
                }
                var i = e.prototype;
                i.addCell = function (t) {
                    this.cells.push(t);
                    this.outerWidth += t.size.outerWidth;
                    this.height = Math.max(t.size.outerHeight, this.height);
                    if (1 == this.cells.length) {
                        this.x = t.x;
                        var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                        this.firstMargin = t.size[e];
                    }
                };
                i.updateTarget = function () {
                    var t = this.isOriginLeft ? "marginRight" : "marginLeft";
                    var e = this.getLastCell();
                    var i = e ? e.size[t] : 0;
                    var n = this.outerWidth - (this.firstMargin + i);
                    this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
                };
                i.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                };
                i.select = function () {
                    this.cells.forEach(function (t) {
                        t.select();
                    });
                };
                i.unselect = function () {
                    this.cells.forEach(function (t) {
                        t.unselect();
                    });
                };
                i.getCellElements = function () {
                    return this.cells.map(function (t) {
                        return t.element;
                    });
                };
                return e;
            });
        },
        768: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true) !((n = o), (s = "function" === typeof n ? n.call(e, i, e, t) : n), void 0 !== s && (t.exports = s));
            })(window, function t() {
                "use strict";
                function e(t) {
                    var e = parseFloat(t);
                    var i = -1 == t.indexOf("%") && !isNaN(e);
                    return i && e;
                }
                function i() {}
                var n =
                    "undefined" == typeof console
                        ? i
                        : function (t) {
                              void 0;
                          };
                var s = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
                var r = s.length;
                function o() {
                    var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 };
                    for (var e = 0; e < r; e++) {
                        var i = s[e];
                        t[i] = 0;
                    }
                    return t;
                }
                function a(t) {
                    var e = getComputedStyle(t);
                    if (!e) n("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? " + "See https://bit.ly/getsizebug1");
                    return e;
                }
                var l = false;
                var h;
                function c() {
                    if (l) return;
                    l = true;
                    var t = document.createElement("div");
                    t.style.width = "200px";
                    t.style.padding = "1px 2px 3px 4px";
                    t.style.borderStyle = "solid";
                    t.style.borderWidth = "1px 2px 3px 4px";
                    t.style.boxSizing = "border-box";
                    var i = document.body || document.documentElement;
                    i.appendChild(t);
                    var n = a(t);
                    h = 200 == Math.round(e(n.width));
                    u.isBoxSizeOuter = h;
                    i.removeChild(t);
                }
                function u(t) {
                    c();
                    if ("string" == typeof t) t = document.querySelector(t);
                    if (!t || "object" != typeof t || !t.nodeType) return;
                    var i = a(t);
                    if ("none" == i.display) return o();
                    var n = {};
                    n.width = t.offsetWidth;
                    n.height = t.offsetHeight;
                    var l = (n.isBorderBox = "border-box" == i.boxSizing);
                    for (var u = 0; u < r; u++) {
                        var d = s[u];
                        var f = i[d];
                        var p = parseFloat(f);
                        n[d] = !isNaN(p) ? p : 0;
                    }
                    var v = n.paddingLeft + n.paddingRight;
                    var g = n.paddingTop + n.paddingBottom;
                    var m = n.marginLeft + n.marginRight;
                    var y = n.marginTop + n.marginBottom;
                    var b = n.borderLeftWidth + n.borderRightWidth;
                    var w = n.borderTopWidth + n.borderBottomWidth;
                    var S = l && h;
                    var C = e(i.width);
                    if (false !== C) n.width = C + (S ? 0 : v + b);
                    var x = e(i.height);
                    if (false !== x) n.height = x + (S ? 0 : g + w);
                    n.innerWidth = n.width - (v + b);
                    n.innerHeight = n.height - (g + w);
                    n.outerWidth = n.width + m;
                    n.outerHeight = n.height + y;
                    return n;
                }
                return u;
            });
        },
        385: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(497)]),
                    (s = function (t) {
                        return o(r, t);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i) {
                "use strict";
                function n() {}
                var s = (n.prototype = Object.create(i.prototype));
                s.bindHandles = function () {
                    this._bindHandles(true);
                };
                s.unbindHandles = function () {
                    this._bindHandles(false);
                };
                s._bindHandles = function (t) {
                    t = void 0 === t ? true : t;
                    var i = t ? "addEventListener" : "removeEventListener";
                    var n = t ? this._touchActionValue : "";
                    for (var s = 0; s < this.handles.length; s++) {
                        var r = this.handles[s];
                        this._bindStartEvent(r, t);
                        r[i]("click", this);
                        if (e.PointerEvent) r.style.touchAction = n;
                    }
                };
                s._touchActionValue = "none";
                s.pointerDown = function (t, e) {
                    var i = this.okayPointerDown(t);
                    if (!i) return;
                    this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY };
                    t.preventDefault();
                    this.pointerDownBlur();
                    this._bindPostStartEvents(t);
                    this.emitEvent("pointerDown", [t, e]);
                };
                var r = { TEXTAREA: true, INPUT: true, SELECT: true, OPTION: true };
                var o = { radio: true, checkbox: true, button: true, submit: true, image: true, file: true };
                s.okayPointerDown = function (t) {
                    var e = r[t.target.nodeName];
                    var i = o[t.target.type];
                    var n = !e || i;
                    if (!n) this._pointerReset();
                    return n;
                };
                s.pointerDownBlur = function () {
                    var t = document.activeElement;
                    var e = t && t.blur && t != document.body;
                    if (e) t.blur();
                };
                s.pointerMove = function (t, e) {
                    var i = this._dragPointerMove(t, e);
                    this.emitEvent("pointerMove", [t, e, i]);
                    this._dragMove(t, e, i);
                };
                s._dragPointerMove = function (t, e) {
                    var i = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
                    if (!this.isDragging && this.hasDragStarted(i)) this._dragStart(t, e);
                    return i;
                };
                s.hasDragStarted = function (t) {
                    return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
                };
                s.pointerUp = function (t, e) {
                    this.emitEvent("pointerUp", [t, e]);
                    this._dragPointerUp(t, e);
                };
                s._dragPointerUp = function (t, e) {
                    if (this.isDragging) this._dragEnd(t, e);
                    else this._staticClick(t, e);
                };
                s._dragStart = function (t, e) {
                    this.isDragging = true;
                    this.isPreventingClicks = true;
                    this.dragStart(t, e);
                };
                s.dragStart = function (t, e) {
                    this.emitEvent("dragStart", [t, e]);
                };
                s._dragMove = function (t, e, i) {
                    if (!this.isDragging) return;
                    this.dragMove(t, e, i);
                };
                s.dragMove = function (t, e, i) {
                    t.preventDefault();
                    this.emitEvent("dragMove", [t, e, i]);
                };
                s._dragEnd = function (t, e) {
                    this.isDragging = false;
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks;
                        }.bind(this)
                    );
                    this.dragEnd(t, e);
                };
                s.dragEnd = function (t, e) {
                    this.emitEvent("dragEnd", [t, e]);
                };
                s.onclick = function (t) {
                    if (this.isPreventingClicks) t.preventDefault();
                };
                s._staticClick = function (t, e) {
                    if (this.isIgnoringMouseUp && "mouseup" == t.type) return;
                    this.staticClick(t, e);
                    if ("mouseup" != t.type) {
                        this.isIgnoringMouseUp = true;
                        setTimeout(
                            function () {
                                delete this.isIgnoringMouseUp;
                            }.bind(this),
                            400
                        );
                    }
                };
                s.staticClick = function (t, e) {
                    this.emitEvent("staticClick", [t, e]);
                };
                n.getPointerPoint = i.getPointerPoint;
                return n;
            });
        },
        497: function (t, e, i) {
            var n, s;
            (function (r, o) {
                if (true)
                    !((n = [i(323)]),
                    (s = function (t) {
                        return o(r, t);
                    }.apply(e, n)),
                    void 0 !== s && (t.exports = s));
            })(window, function t(e, i) {
                "use strict";
                function n() {}
                function s() {}
                var r = (s.prototype = Object.create(i.prototype));
                r.bindStartEvent = function (t) {
                    this._bindStartEvent(t, true);
                };
                r.unbindStartEvent = function (t) {
                    this._bindStartEvent(t, false);
                };
                r._bindStartEvent = function (t, i) {
                    i = void 0 === i ? true : i;
                    var n = i ? "addEventListener" : "removeEventListener";
                    var s = "mousedown";
                    if ("ontouchstart" in e) s = "touchstart";
                    else if (e.PointerEvent) s = "pointerdown";
                    t[n](s, this);
                };
                r.handleEvent = function (t) {
                    var e = "on" + t.type;
                    if (this[e]) this[e](t);
                };
                r.getTouch = function (t) {
                    for (var e = 0; e < t.length; e++) {
                        var i = t[e];
                        if (i.identifier == this.pointerIdentifier) return i;
                    }
                };
                r.onmousedown = function (t) {
                    var e = t.button;
                    if (e && 0 !== e && 1 !== e) return;
                    this._pointerDown(t, t);
                };
                r.ontouchstart = function (t) {
                    this._pointerDown(t, t.changedTouches[0]);
                };
                r.onpointerdown = function (t) {
                    this._pointerDown(t, t);
                };
                r._pointerDown = function (t, e) {
                    if (t.button || this.isPointerDown) return;
                    this.isPointerDown = true;
                    this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier;
                    this.pointerDown(t, e);
                };
                r.pointerDown = function (t, e) {
                    this._bindPostStartEvents(t);
                    this.emitEvent("pointerDown", [t, e]);
                };
                var o = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
                r._bindPostStartEvents = function (t) {
                    if (!t) return;
                    var i = o[t.type];
                    i.forEach(function (t) {
                        e.addEventListener(t, this);
                    }, this);
                    this._boundPointerEvents = i;
                };
                r._unbindPostStartEvents = function () {
                    if (!this._boundPointerEvents) return;
                    this._boundPointerEvents.forEach(function (t) {
                        e.removeEventListener(t, this);
                    }, this);
                    delete this._boundPointerEvents;
                };
                r.onmousemove = function (t) {
                    this._pointerMove(t, t);
                };
                r.onpointermove = function (t) {
                    if (t.pointerId == this.pointerIdentifier) this._pointerMove(t, t);
                };
                r.ontouchmove = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    if (e) this._pointerMove(t, e);
                };
                r._pointerMove = function (t, e) {
                    this.pointerMove(t, e);
                };
                r.pointerMove = function (t, e) {
                    this.emitEvent("pointerMove", [t, e]);
                };
                r.onmouseup = function (t) {
                    this._pointerUp(t, t);
                };
                r.onpointerup = function (t) {
                    if (t.pointerId == this.pointerIdentifier) this._pointerUp(t, t);
                };
                r.ontouchend = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    if (e) this._pointerUp(t, e);
                };
                r._pointerUp = function (t, e) {
                    this._pointerDone();
                    this.pointerUp(t, e);
                };
                r.pointerUp = function (t, e) {
                    this.emitEvent("pointerUp", [t, e]);
                };
                r._pointerDone = function () {
                    this._pointerReset();
                    this._unbindPostStartEvents();
                    this.pointerDone();
                };
                r._pointerReset = function () {
                    this.isPointerDown = false;
                    delete this.pointerIdentifier;
                };
                r.pointerDone = n;
                r.onpointercancel = function (t) {
                    if (t.pointerId == this.pointerIdentifier) this._pointerCancel(t, t);
                };
                r.ontouchcancel = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    if (e) this._pointerCancel(t, e);
                };
                r._pointerCancel = function (t, e) {
                    this._pointerDone();
                    this.pointerCancel(t, e);
                };
                r.pointerCancel = function (t, e) {
                    this.emitEvent("pointerCancel", [t, e]);
                };
                s.getPointerPoint = function (t) {
                    return { x: t.pageX, y: t.pageY };
                };
                return s;
            });
        },
        460: function () {
            __loadjs = (function () {
                var t = function () {},
                    e = {},
                    i = {},
                    n = {};
                function s(t, e) {
                    if (t) {
                        var s = n[t];
                        if (((i[t] = e), s)) for (; s.length; ) s[0](t, e), s.splice(0, 1);
                    }
                }
                function r(e, i) {
                    e.call && (e = { success: e }), i.length ? (e.error || t)(i) : (e.success || t)(e);
                }
                function o(e, i, n, s) {
                    var r,
                        a,
                        l = document,
                        h = n.async,
                        c = (n.numRetries || 0) + 1,
                        u = n.before || t,
                        d = e.replace(/[\?|#].*$/, ""),
                        f = e.replace(/^(css|img)!/, "");
                    (s = s || 0),
                        /(^css!|\.css$)/.test(d)
                            ? (((a = l.createElement("link")).rel = "stylesheet"), (a.href = f), (r = "hideFocus" in a) && a.relList && ((r = 0), (a.rel = "preload"), (a.as = "style")))
                            : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d)
                            ? ((a = l.createElement("img")).src = f)
                            : (((a = l.createElement("script")).src = e), (a.async = void 0 === h || h)),
                        !(a.onload = a.onerror = a.onbeforeload = function (t) {
                            var l = t.type[0];
                            if (r)
                                try {
                                    a.sheet.cssText.length || (l = "e");
                                } catch (t) {
                                    18 != t.code && (l = "e");
                                }
                            if ("e" == l) {
                                if ((s += 1) < c) return o(e, i, n, s);
                            } else if ("preload" == a.rel && "style" == a.as) return (a.rel = "stylesheet");
                            i(e, l, t.defaultPrevented);
                        }) !== u(e, a) && l.head.appendChild(a);
                }
                function a(t, i, n) {
                    var a, l;
                    if ((i && i.trim && (a = i), (l = (a ? n : i) || {}), a)) {
                        if (a in e) throw "LoadJS";
                        e[a] = !0;
                    }
                    function h(e, i) {
                        !(function (t, e, i) {
                            var n,
                                s,
                                r = (t = t.push ? t : [t]).length,
                                a = r,
                                l = [];
                            for (
                                n = function (t, i, n) {
                                    if (("e" == i && l.push(t), "b" == i)) {
                                        if (!n) return;
                                        l.push(t);
                                    }
                                    --r || e(l);
                                },
                                    s = 0;
                                s < a;
                                s++
                            )
                                o(t[s], n, i);
                        })(
                            t,
                            function (t) {
                                r(l, t), e && r({ success: e, error: i }, t), s(a, t);
                            },
                            l
                        );
                    }
                    if (l.returnPromise) return new Promise(h);
                    h();
                }
                return (
                    (a.ready = function (t, e) {
                        return (
                            (function (t, e) {
                                t = t.push ? t : [t];
                                var s,
                                    r,
                                    o,
                                    a = [],
                                    l = t.length,
                                    h = l;
                                for (
                                    s = function (t, i) {
                                        i.length && a.push(t), --h || e(a);
                                    };
                                    l--;

                                )
                                    (r = t[l]), (o = i[r]) ? s(r, o) : (n[r] = n[r] || []).push(s);
                            })(t, function (t) {
                                r(e, t);
                            }),
                            a
                        );
                    }),
                    (a.done = function (t) {
                        s(t, []);
                    }),
                    (a.reset = function () {
                        (e = {}), (i = {}), (n = {});
                    }),
                    (a.isDefined = function (t) {
                        return t in e;
                    }),
                    a
                );
            })();
        },
        997: function () {
            const t = (t, e, i) => {
                if (!t || !i) return;
                const n = i.total_price;
                const s = formatMoney(n, window.FoxThemeSettings.money_format);
                const r = `${window.FoxThemeStrings.newSubTotal}: ${s}`;
                t.textContent = r;
                t.setAttribute("aria-hidden", false);
                e.setAttribute("aria-hidden", true);
                window.setTimeout(() => {
                    t.setAttribute("aria-hidden", true);
                }, 1e3);
            };
            const e = (t, e) => {
                if (!t) return false;
                const i = window.FoxThemeStrings.quantityError.replace("[quantity]", e);
                window.FoxTheme.Notification.show({ target: t, method: "appendChild", type: "warning", message: i, last: 3e3 });
            };
            const i = (t) => {
                const e = document.querySelectorAll("[data-cart-count-number]");
                e &&
                    e.forEach((e) => {
                        const i = e.closest("[data-cart-count-bubble]");
                        e.textContent = t;
                        if (0 === t) i.classList.add("is-cart-empty");
                        else i.classList.remove("is-cart-empty");
                    });
            };
            const n = (t) => {
                const e = formatMoney(t, window.FoxThemeSettings.money_format);
                const i = document.body.querySelectorAll("[data-cart-price]");
                i &&
                    i.forEach((t) => {
                        t.innerHTML = e;
                    });
            };
            const s = (t) => {
                if (!t) return;
                return fetchSection("cart-discounts")
                    .then((e) => {
                        const i = e.querySelector("#shopify-section-cart-discounts").innerHTML;
                        t.innerHTML = i;
                    })
                    .catch((t) => {});
            };
            const r = () =>
                fetch(`/cart.js`, { credentials: "same-origin", headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;" } }).then((t) => {
                    if (!t.ok) throw t;
                    return t.json();
                });
            window.FoxThemeCartHelpers = window.FoxThemeCartHelpers || {};
            window.FoxThemeCartHelpers = { updateCartCount: i, updateSubtotalPrice: n, updateLineItemError: e, updateLiveRegions: t, renderCartFooter: s, getState: r };
        },
    };
    var e = {};
    function i(n) {
        var s = e[n];
        if (void 0 !== s) return s.exports;
        var r = (e[n] = { exports: {} });
        t[n].call(r.exports, r, r.exports, i);
        return r.exports;
    }
    !(function () {
        i.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t["default"];
                      }
                    : function () {
                          return t;
                      };
            i.d(e, { a: e });
            return e;
        };
    })();
    !(function () {
        i.d = function (t, e) {
            for (var n in e) if (i.o(e, n) && !i.o(t, n)) Object.defineProperty(t, n, { enumerable: true, get: e[n] });
        };
    })();
    !(function () {
        i.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        };
    })();
    var n = {};
    !(function () {
        "use strict";
        var t = i(408);
        var e = i.n(t);
        var n = i(707);
        var s = i.n(n);
        var r = i(364);
        var o = i(459);
        class a {
            noti = null;
            removeTimeoutId = null;
            hideTimeoutId = null;
            transitionDuration = 300;
            constructor() {}
            setNoti = (t, e, i) => {
                let n;
                if ("warning" === t)
                    n = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
                else if ("success" === t)
                    n = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
                this.noti = document.createElement("div");
                this.noti.classList.add("f-notification");
                this.noti.classList.add(t);
                if (i) this.noti.classList.add("f-notification--sticky");
                this.noti.innerHTML = `${n}<div class="ml-3">${e}</div>`;
            };
            show = ({ target: t, type: e, message: i, method: n = "after", last: s = 3e3, delay: r = 0, debug: o = false, sticky: a = false }) => {
                this.clearTimeout();
                this.removeNoti();
                this.setNoti(e, i, a);
                setTimeout(() => {
                    t?.[n](this.noti);
                    requestAnimationFrame(() => this.noti.classList.add("show"));
                    if (!o)
                        this.hideTimeoutId = setTimeout(() => {
                            this.noti.classList.add("hide");
                            this.removeTimeoutId = setTimeout(this.removeNoti, 2 * this.transitionDuration);
                        }, s);
                }, r);
            };
            handleClick = () => {
                clearTimeout(this.removeTimeoutId);
                this.noti.classList.add("f-hidden");
                setTimeout(this.removeNoti, 2 * this.transitionDuration);
            };
            clearTimeout = () => {
                clearTimeout(this.removeTimeoutId);
                clearTimeout(this.hideTimeoutId);
            };
            removeNoti = () => {
                if (this.noti) this.noti.remove();
            };
        }
        class l {
            constructor() {
                this.events = {};
            }
            get evts() {
                return Object.keys(this.events);
            }
            subscribe(t, e) {
                this.events[t] = this.events[t] || [];
                this.events[t].push(e);
                return () => this.unSubscribe(t, e);
            }
            unSubscribe(t, e) {
                const i = this.events[t];
                if (i && Array.isArray(i))
                    for (let t = 0; t < i.length; t++)
                        if (i[t] === e) {
                            i.splice(t, 1);
                            break;
                        }
            }
            emit(t, ...e) {
                void 0;
                void 0;
                void 0;
                (this.events[t] || []).forEach((t) => {
                    t(...e);
                });
            }
        }
        var h = i(997);
        class c {
            constructor(t, e = {}) {
                if (!t) return;
                this.container = t;
                const { sliderOptions: i } = t.dataset;
                const n = i ? JSON.parse(i) : {};
                this.options = { ...n, ...e };
                const { on: s = {}, onReady: r = () => {} } = e;
                this.settings = {
                    cellAlign: "left",
                    watchCSS: true,
                    pageDots: false,
                    autoPlay: false,
                    prevNextButtons: false,
                    wrapAround: false,
                    pauseAutoPlayOnHover: false,
                    freeScrollFriction: 0.01,
                    ...this.options,
                    on: {
                        ...s,
                        ready: () => {
                            r();
                            this._onInit();
                        },
                    },
                };
                this.init();
            }
            init = () => {
                this.container?.classList.add("flickity-wrapper");
                if (this.settings.adaptiveHeight) this.container?.classList.add("flickity-adaptive-height");
                this.instance = new window.FoxTheme.Flickity(this.container, this.settings);
            };
            calcArrowsPos = () => {
                const t = this.container?.querySelector(".f-image");
                if (t) {
                    let e = t.clientHeight;
                    if (0 === e) e = "50%";
                    this.container.style.setProperty("--arrows-offset-top", parseInt(e) / 2 + "px");
                    this.container.classList.add("flickity-button-initialized");
                }
            };
            _onInit = () => {
                const { prevNextButtons: t, pageDots: e } = this.options;
                const { calcButtonPosition: i } = this.container.dataset;
                if (t && "true" === i) {
                    this.container?.classList.add("flickity-with-nav");
                    setTimeout(() => this.calcArrowsPos(), 500);
                }
                if (e) this.container?.classList.add("flickity-with-dots");
                this.initialized = true;
            };
            destroy = () => {
                this.instance.destroy();
                this.initialized = false;
            };
        }
        function u(t) {
            return fetch("/products/" + t + ".js").then(function (t) {
                return t.json();
            });
        }
        function d(t, e) {
            g(t);
            if ("number" !== typeof e) throw new TypeError(e + " is not a Number.");
            var i = t.variants.filter(function (t) {
                return t.id === e;
            });
            return i[0] || null;
        }
        function f(t, e) {
            g(t);
            var i = v(t, e);
            return p(t, i);
        }
        function p(t, e) {
            g(t);
            y(e);
            var i = t.variants.filter(function (t) {
                return e.every(function (e, i) {
                    return t.options[i] === e;
                });
            });
            return i[0] || null;
        }
        function v(t, e) {
            g(t);
            m(e);
            var i = [];
            e.forEach(function (e) {
                for (var n = 0; n < t.options.length; n++)
                    if (t.options[n].name.toLowerCase() === e.name.toLowerCase()) {
                        i[n] = e.value;
                        break;
                    }
            });
            return i;
        }
        function g(t) {
            if ("object" !== typeof t) throw new TypeError(t + " is not an object.");
            if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
        }
        function m(t) {
            if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
            if (0 === t.length) return [];
            if (t[0].hasOwnProperty("name")) {
                if ("string" !== typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
            } else throw new Error(t[0] + "does not contain name key.");
        }
        function y(t) {
            if (Array.isArray(t) && "object" === typeof t[0]) throw new Error(t + "is not a valid array of options.");
        }
        var b = i(460);
        class w {
            confettiInterval = null;
            containerEl = null;
            confettiColors = ["#EF2964", "#00C09D", "#2D87B0", "#48485E", "#EFFF1D"];
            confettiAnimations = ["slow", "medium", "fast"];
            timeRun = 0;
            constructor(t) {
                this.container = t;
                this.setupElement();
                this.render();
            }
            setupElement = () => {
                const t = document.createElement("div");
                const e = this.container.style.position;
                if ("relative" !== e || "absolute" !== e) this.container.style.position = "relative";
                t.classList.add("f-confetti-container");
                this.container.appendChild(t);
                this.containerEl = t;
            };
            stopConfetti = () => {
                clearInterval(this.confettiInterval);
                setTimeout(() => this.containerEl.remove(), 1500);
            };
            render = () => {
                this.confettiInterval = setInterval(() => {
                    this.timeRun += 1;
                    if (this.timeRun >= 160) this.stopConfetti();
                    const t = document.createElement("div");
                    const e = Math.floor(3 * Math.random()) + 7 + "px";
                    const i = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
                    const n = Math.floor(Math.random() * this.container.offsetWidth) + "px";
                    const s = this.confettiAnimations[Math.floor(Math.random() * this.confettiAnimations.length)];
                    t.classList.add("f-confetti", "f-confetti--animation-" + s);
                    t.style.left = n;
                    t.style.width = e;
                    t.style.height = e;
                    t.style.backgroundColor = i;
                    t.removeTimeout = setTimeout(function () {
                        t.parentNode.removeChild(t);
                    }, 3e3);
                    this.containerEl.appendChild(t);
                }, 20);
            };
        }
        window.FoxTheme = window.FoxTheme || {};
        window.FoxTheme = { Flickity: s(), Slider: c, AnimateLoading: e(), Notification: new a(), ProductHelper: { getVariantFromOptionArray: p }, Confetti: w };
        window.FoxThemeEvents = window.FoxThemeEvents || new l();
        window.FoxTheme.loadjs = __loadjs;
        (function t() {
            const { FoxThemeSettings: e } = window;
            try {
                e.colorSwatches = [];
                e.imageSwatches = [];
                e.custom_colors
                    .split(",")
                    .filter(Boolean)
                    .forEach((t) => {
                        const [i, n] = t.split(":");
                        e.colorSwatches.push({ key: i.trim().toLowerCase(), value: n?.trim?.() || "" });
                    });
                Object.keys(e).forEach((t) => {
                    if (t.includes("custom_image") && !t.includes(".png")) if (e[`${t}.png`]) e.imageSwatches.push({ key: e[t].toLowerCase(), value: e[`${t}.png`] });
                });
            } catch (t) {
                void 0;
            }
        })();
    })();
})();
